import { useIsMobile } from "@/hooks/useIsMobile";
import { RiRoadMapLine } from "react-icons/ri";
import classes from "@/styles/fulfilment-partners/intelcom.module.css";
import Image from "next/image";
import { integrationImg, intelcomImages } from "@/utils/images";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Container,
  Row,
} from "reactstrap";
import { FaRegCalendarCheck } from "react-icons/fa";
import { MdOutlineMarkUnreadChatAlt } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import { TbAugmentedReality } from "react-icons/tb";
import { LuTruck } from "react-icons/lu";
import Link from "next/link";
import { useState } from "react";

export default function IntelcomMain() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const intelcomIcons = [
    {
      icon: <FaRegCalendarCheck />,
      heading: "7-day delivery",
      para: "That's 365 days a year, rain or shine",
    },
    {
      icon: <MdOutlineMarkUnreadChatAlt />,
      heading: "Consumer notifications",
      para: "Both shipper and recipient receive notifications",
    },
    {
      icon: <BiSupport />,
      heading: "Customer support",
      para: "Our bilingual call center is standing by.",
    },
    {
      icon: <RiRoadMapLine />,
      heading: "Real-time tracking",
      para: "Follow every parcel right to customers' doors",
    },
    {
      icon: <TbAugmentedReality />,
      heading: "Remote or alternative locations",
      para: "Ship to counters, smart parcel lockers, you name it",
    },
    {
      icon: <LuTruck />,
      heading: "We get it done!",
      para: "With no surcharge for Peak or rural locations and up to 3 delivery or return pickup attempts at no extra charge",
    },
  ];

  return (
    <div className={isMobile ? classes.containerMobile : classes.container}>
      <div className={classes.header}>
        <Image
          className={classes.headerImage}
          src={intelcomImages["header-img"]}
          alt="Header Image"
          width={isMobile ? 600 : 1522}
          height={isMobile ? 300 : 600}
          quality={100}
        />
      </div>
      <section className="my-3 container">
        <h3>About Intelcom | Dragonfly</h3>
        <p>
          Intelcom | Dragonfly is a last-mile logistics company that facilitates
          the delivery of packages across Canada every day. A leader thanks to
          its technology platform that generates optimized routes daily,
          Intelcom | Dragonfly enables its clients to offer consumers a fast,
          reliable, and predictable delivery service for their online purchases
        </p>
        {/* Map Image */}
        <Container className={classes.rowImage_margin}>
          <Row style={{ background: "#e6f6f4" }} sm={1} xs={1} md={2}>
            <Col>
              <Image
                src={intelcomImages["intelcom-2"]}
                className={classes.pageImage}
                alt="Stats Image"
                width={500}
                height={500}
                quality={100}
              />
            </Col>
            {isMobile ? (
              <Col className={classes.pageImageText}>
                <h5 className={classes.text_normal}>Network</h5>
                <h6>85+ stations across Canada</h6>
                <br />
                <h5 className={classes.text_normal}>Coverage</h5>
                <h6>90% reach of Canadian addresses</h6>
                <br />
                <h5 className={classes.text_normal}>Satisfied customers</h5>
                <h6>4.7/5 average consumer satisfaction</h6>
                <h6>based on 2.0M reviews in 2024</h6>
              </Col>
            ) : (
              <Col className={classes.pageImageText}>
                <h4 className={classes.text_normal}>Network</h4>
                <h5>85+ stations across Canada</h5>
                <br />
                <h4 className={classes.text_normal}>Coverage</h4>
                <h5>90% reach of Canadian addresses</h5>
                <br />
                <h4 className={classes.text_normal}>Satisfied customers</h4>
                <h5>4.7/5 average consumer satisfaction</h5>
                <h5>based on 2.0M reviews in 2024</h5>
              </Col>
            )}
          </Row>
        </Container>
        {/* Package Image */}
        <Row sm={1} xs={1} md={2} className={classes.rowImage_margin}>
          <Col className={classes.pageImageText}>
            <h4 className={classes.text_normal}>
              Reliable last-mile delivery, 7 days a week
            </h4>
            <br />
            <p>
              Fast deliveries, from coast to coast,{" "}
              <b>7 days/week, between 8 am to 10 pm.</b>
            </p>
            <p>
              Handover your parcels at any time of the day via our Canadian hub
              stations and we&#8217;ll handle the rest so you can deliver on
              your customer promise.
            </p>
            <p>
              Our flexible operational model can accommodate high volume
              fluctuations at any time meaning your parcels get to where
              they&#8217;re going, fast.
            </p>
          </Col>
          <Col>
            <Image
              src={intelcomImages["intelcom-7"]}
              className={classes.pageImage}
              alt="Stats Image"
              width={500}
              height={500}
              quality={100}
            />
          </Col>
        </Row>
        {/* Device Image */}
        <Row sm={1} xs={1} md={2} className={classes.rowImage_margin}>
          <Col>
            <Image
              src={intelcomImages["intelcom-6"]}
              className={classes.pageImage}
              alt="Stats Image"
              width={500}
              height={500}
              quality={100}
            />
          </Col>
          <Col className={classes.pageImageText}>
            <h4 className={classes.text_normal}>
              Deliver an unparalleled customer experience
            </h4>
            <br />
            <p>
              Customer experience is always our top priority and with over 2.0 M
              Canadians rating us at 4.7 on 5 stars in our 2024 satisfaction
              surveys, it shows. We&#8217;re constantly fueling innovation to
              improve our services based on your customer needs.
            </p>
            <p>
              Our bilingual Customer Experience Team is never more than a call
              or click away to assist for any unforeseen issues.
            </p>
          </Col>
        </Row>
        {/* Divider */}
        <div className={classes.divider} />
        {/* Icons Grid */}
        <Container>
          <h4
            className={isMobile ? classes.iconHeaderMobile : classes.iconHeader}
          >
            All the perks, all included.
          </h4>
          <Row xs={1} sm={2} md={3}>
            {intelcomIcons.map((icon, i) => (
              <Col key={i}>
                <div
                  className={
                    isMobile
                      ? classes.iconContainerMobile
                      : classes.iconContainer
                  }
                >
                  <div className={isMobile ? classes.iconMobile : classes.icon}>
                    {icon.icon}
                  </div>
                  <h5>{icon.heading}</h5>
                  <p>{icon.para}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
        {/* Divider */}
        <div className={classes.divider} />
        <div style={{ marginBottom: "80px" }}></div>
        {/* Green logistics */}
        <Row sm={1} xs={1} md={2} className={classes.rowImage_margin}>
          <Col>
            <Image
              src={intelcomImages["intelcom-15"]}
              className={classes.pageImage}
              alt="Stats Image"
              width={500}
              height={500}
              quality={100}
            />
          </Col>
          <Col className={classes.pageImageText}>
            <h4 className={classes.text_normal}>
              Working towards green logistics
            </h4>
            <br />
            <p>
              We are one of 300+ global businesses having signed{" "}
              <Link
                className={classes.link}
                href="https://www.theclimatepledge.com/"
              >
                <u>The Climate Pledge</u>
              </Link>{" "}
              . What does this mean? Our company will drive sustainable
              innovation to be <b>net zero carbon by 2040</b> because climate
              action can&#8217;t wait.
            </p>
            <p>
              This commitment underscores our sense of responsibility in working
              towards a solution to address this pressing issue.
            </p>
          </Col>
        </Row>
        {/* FAQ */}
        <h4 className={classes.text_normal}>Frequently asked questions</h4>
        <br />
        <div>
          {/*@ts-ignore*/}
          <Accordion open={open} toggle={toggle}>
            <AccordionItem>
              <AccordionHeader targetId="1">
                What is the difference between Intelcom and Dragonfly?
              </AccordionHeader>
              <AccordionBody accordionId="1">
                While the Intelcom name continues to be used in Quebec in honour
                of our roots, Dragonfly is now the brand name under which we
                operate in the rest of Canada and globally.
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="2">
                What are your package requirements?
              </AccordionHeader>
              <AccordionBody accordionId="2">
                All packages must weigh under 149 lbs and not contain any{" "}
                <Link
                  className={classes.link}
                  href="https://laws-lois.justice.gc.ca/eng/regulations/SOR-2001-286/"
                  target="_blank"
                >
                  <u>dangerous goods</u>
                </Link>
                .
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="3">
                How can I contact Intelcom | Dragonfly?
              </AccordionHeader>
              <AccordionBody accordionId="3">
                You won&apos;t need to get in touch with Intelcom | Dragonfly
                directly while shipping with ShipVista. If you want to learn
                more, please visit our{" "}
                <Link className={classes.link} href="https://intelcom.ca/en/">
                  <u>website</u>
                </Link>
                .
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
      </section>
    </div>
  );
}
